import { useNavigate } from "react-router-dom";

type Props = {
  title: string;
  desc: string;
  image: string;
  url: string;
};

export default function ServiceCard({ title, desc, image, url }: Props) {
  const navigate = useNavigate();

  return (
    <button
      onClick={() => navigate(url)}
      className="h-full text-left"
    >
      <div
        className="
          flex h-full flex-col
          overflow-hidden rounded-xl
          bg-white border shadow-sm
          transition hover:shadow-md
        "
      >
        {/* Image */}
        <div className="h-48 w-full overflow-hidden">
          <img
            src={image}
            alt={title}
            className="h-full w-full object-cover"
          />
        </div>

        {/* Content */}
        <div className="flex flex-1 flex-col p-6">
          <h3 className="text-lg font-semibold text-gray-900">
            {title}
          </h3>

          {/* Description grows to fill space */}
          <p className="mt-3 flex-1 text-sm text-gray-600"  dangerouslySetInnerHTML={{ __html: desc }}/>

        </div>
      </div>
    </button>
  );
}
